import moment from "moment";

/**
 * Generates dynamic columns based on data keys and humanizes titles.
 * @param {Array} data - The table data from API.
 * @param {Array} existingColumns - Predefined columns with special renders/logic.
 * @returns {Array} - Combined dynamic columns.
 */
export const generateDynamicColumns = (data, existingColumns = []) => {
  if (!data || data.length === 0) return existingColumns;

  // Use the first record as a template for columns and their order
  const firstRecord = data[0];
  const keys = Object.keys(firstRecord);

  const dynamicColumns = keys
    .filter((key) => {
      const lowerKey = key.toLowerCase();
      // Keep delivery_agent_id and tracking_id as explicitly requested
      if (lowerKey === "delivery_agent_id" || lowerKey === "tracking_id") return true;
      
      // Hide cp id and hub id and other id's columns
      // Logic: hide if contains 'id' unless it's 'delivery_agent_id'
      if (lowerKey.includes("id") || lowerKey.endsWith("_id")) {
        // Specific check for 'cp' and 'hub' related IDs if they don't match exactly but contain it
        return false;
      }
      return true;
    })
    .map((key) => {
      // Check if we have an existing definition for this key
      const existing = existingColumns.find(
        (col) => col.dataIndex === key || col.key === key,
      );
      
      if (existing) {
        return { ...existing };
      }

      // Humanize title (e.g., booking_date_time -> Booking Date Time)
      const title = key
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      const col = {
        title,
        dataIndex: key,
        key: key,
        width: 150,
        render: (text) => (text !== undefined && text !== null && text !== "" ? text : "-"),
      };

      // Auto-format dates/times if they follow naming conventions
      const lowerKey = key.toLowerCase();
      if (
        lowerKey.includes("date") || 
        lowerKey.includes("time") || 
        lowerKey.endsWith("_at")
      ) {
        col.render = (text) => (text ? moment(text).format("DD-MM-YYYY hh:mm A") : "-");
        col.width = 180;
      }

      return col;
    });

  return dynamicColumns;
};
